import React from 'react';
import { FiShield, FiTruck, FiAward, FiPercent } from 'react-icons/fi';
import BrandMarquee from './BrandMarquee';
import './FeaturesSection.css';

const FeaturesSection = () => {
    return (
        <section id="brand-partners" className="features-guarantee-section" aria-label="Brand Partners & Guarantees">
            {/* Authentic Brand Marquee (Lovable Real Logos) */}
            <BrandMarquee />

            {/* Modern 4-Item Guarantees Bar: Equal Balanced Height & Real Guarantees */}
            <div className="brand-guarantee-container">
                <div className="container">
                    <div className="brand-guarantee-bar">
                        <div className="guarantee-item guarantee-item--packed">
                            <div className="guarantee-icon-wrap">
                                <FiShield className="guarantee-icon" />
                            </div>
                            <div className="guarantee-text">
                                <strong>Original Factory Packed</strong>
                                <span>Factory-sealed with verifiable serial check</span>
                            </div>
                        </div>

                        <div className="guarantee-item guarantee-item--warranty">
                            <div className="guarantee-icon-wrap">
                                <FiAward className="guarantee-icon" />
                            </div>
                            <div className="guarantee-text">
                                <strong>Official Brand Warranty</strong>
                                <span>Claimable at authorized service centers</span>
                            </div>
                        </div>

                        <div className="guarantee-item guarantee-item--delivery">
                            <div className="guarantee-icon-wrap">
                                <FiTruck className="guarantee-icon" />
                            </div>
                            <div className="guarantee-text">
                                <strong>Lahore Express Delivery</strong>
                                <span>Safe doorstep handling by trained crew</span>
                            </div>
                        </div>

                        <div className="guarantee-item guarantee-item--discount">
                            <div className="guarantee-icon-wrap">
                                <FiPercent className="guarantee-icon" />
                            </div>
                            <div className="guarantee-text">
                                <strong>Instant Cash Discount</strong>
                                <span>Immediate cash savings on direct buy</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;

